// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppFooter_app-footer-container__RRzbs {
  color: var(--m-text);
  box-shadow: var(--m-box-shadow-card);
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/AppFooter/AppFooter.module.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,oCAAA;EACA,aAAA;AACJ","sourcesContent":[".app-footer-container {\n    color: var(--m-text);\n    box-shadow: var(--m-box-shadow-card);\n    padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app-footer-container": `AppFooter_app-footer-container__RRzbs`
};
export default ___CSS_LOADER_EXPORT___;
